import React, { useEffect, useState } from 'react';
import axios from '../../utility/customAxios';
import { LinkSourceCodeButton } from './LinkSourceCodeButton';
import { ViewSourceCodeButton } from './ViewSourceCodeButton';
import {useSelector} from "react-redux";
import timerange from "../../store/reducers/timerange";

interface SourceCodeButtonProps {
    serviceName: string;
}

export const SourceCodeButton: React.FC<SourceCodeButtonProps> = ({ serviceName }) => {
    const [hasGithubIntegration, setHasGithubIntegration] = useState(false);
    const [hasLinkedSourceCode, setHasLinkedSourceCode] = useState(false);
    const [loading, setLoading] = useState(true);
    const [sourceCodeUrl, setSourceCodeUrl] = useState<string>("");
    const [sourceCodePath, setSourceCodePath] = useState<string>("");
    const timeRange = useSelector(timerange.selectors.getTimeRange)

    useEffect(() => {
        const checkIntegrationAndSourceCode = async () => {
            try {
                setLoading(true);
                
                // Check if GitHub integration exists
                const integrationResponse = await axios.get("/api/v1/integrationExists?type=githubV2");
                const integrationExists = integrationResponse.data.exists;
                setHasGithubIntegration(integrationExists);

                if (!integrationExists) {
                    setLoading(false);
                    return;
                }

                // Check if service has linked source code
                try {
                    const sourceCodeResponse = await axios.post(`/api/v1/source/repository`, {
                        serviceName: serviceName,
                        startTime: Math.floor(timeRange.getStartEnd()[0].getTime() / 1000),
                        endTime: Math.floor(timeRange.getStartEnd()[1].getTime() / 1000),
                    });
                    if (sourceCodeResponse.data && sourceCodeResponse.data.repository && sourceCodeResponse.data.found) {
                        setHasLinkedSourceCode(sourceCodeResponse.data.found);
                        setSourceCodeUrl(sourceCodeResponse.data.repository);
                        if (sourceCodeResponse.data.servicePath) {
                            setSourceCodePath(sourceCodeResponse.data.servicePath);
                        }
                    } else {
                        setHasLinkedSourceCode(false);
                    }
                } catch (error: any) {
                    if (error.response && error.response.status === 404) {
                        // No source code linked
                        setHasLinkedSourceCode(false);
                    } else {
                        console.error('Error checking source code:', error);
                    }
                }
            } catch (error) {
                console.error('Error checking GitHub integration:', error);
            } finally {
                setLoading(false);
            }
        };

        if (serviceName) {
            checkIntegrationAndSourceCode();
        }
    }, [serviceName]);

    // Don't show button if no GitHub integration
    if (!hasGithubIntegration || loading) {
        return null;
    }

    // Show appropriate button based on whether source code is linked
    if (hasLinkedSourceCode && sourceCodeUrl) {

    if (sourceCodePath) {
        const sourceCodePathToUse = sourceCodePath.startsWith("/") ? sourceCodePath : `/${sourceCodePath}`;
        const urlToUse = sourceCodeUrl.endsWith("/") ? sourceCodeUrl : `${sourceCodeUrl}/`;
            // If source code path is available, append it to the URL
            const fullSourceCodeUrl = `${urlToUse}blob/-${sourceCodePathToUse}`;
            return <ViewSourceCodeButton
                serviceName={serviceName}
                sourceCodeUrl={fullSourceCodeUrl}
                repositoryUrl={sourceCodeUrl}
                servicePath={sourceCodePath}
            />;
        }

        return <ViewSourceCodeButton 
            serviceName={serviceName} 
            sourceCodeUrl={sourceCodeUrl}
            repositoryUrl={sourceCodeUrl}
        />;
    } else {
        return <LinkSourceCodeButton 
            serviceName={serviceName}
        />;
    }
};